import { Component, ErrorInfo, ReactNode, useState } from "react";

interface ErrorBoundaryProps {
    children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean }> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error('Rendering error encountered', error, errorInfo);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return (
                <div>An Error has occurred</div>
            )
        }

        return this.props.children;
    }
}

export const useHandleError = () => {
    const [error, setError] = useState<unknown>(undefined);

    if (error) {
        throw error;
    }

    return setError;
}

export default ErrorBoundary;